import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaMapMarkerAlt, FaClock, FaHeart, FaRegHeart, FaStar } from "react-icons/fa";

export default function TourListCard2({ tour }) {
    const [isFavorite, setIsFavorite] = useState(false);
    const fallbackImage = "/assets/img/tours/default-tour.jpg";

    // API response'una göre tour verilerini düzenle
    const description = "<p>Turkey tours,Istanbul<br><br>We will pick you up from your hotel (city center hotels), then you will meet with your group and guide at meeting point. We will visit Hippodrome, Blue Mosque, Hagia Sophia Grand Mosque and Grand Covered Bazaar. This tour is finished at Grand Bazaar<strong>&nbsp;</strong>.<br><br>Hippodrome, Blue Mosque, Hagia Sophia Grand Mosque, Grand Bazaar<br><br>Pick Up Location : Hotel pick-up service is available only from the hotels located in the city center. There may be an extra charge for transportations from other locations or airport.</p>"

    const tourData = {
        id: tour.id,
        name: tour.name,
        slug: tour.slug,
        image: tour.thumbnail || fallbackImage,
        duration: tour.duration || "Single Day",
        price: tour.price,
        currency: tour.currency?.symbol || "€",
        location: tour.area?.name || "Unknown Location",
        isHighlighted: tour.isHighlighted || false,
        description: tour.description || description
    };

    
    const handleFavoriteClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsFavorite(!isFavorite);
    };

    return (
        <div className="col-12 mb-4">
            <div 
                className="card border-0 shadow-sm"
                style={{
                    borderRadius: '12px',
                    transition: 'all 0.3s ease',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
                }}
                onMouseEnter={(e) => {
                    e.currentTarget.style.boxShadow = '0 8px 25px rgba(0,0,0,0.15)';
                    e.currentTarget.style.transform = 'translateY(-2px)';
                }}
                onMouseLeave={(e) => {
                    e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.08)';
                    e.currentTarget.style.transform = 'translateY(0)';
                }}
            >
                <div className="card-body p-0">
                    <div className="row g-0">
                        {/* Tour Image */}
                        <div className="col-lg-4 col-md-5">
                            <div className="position-relative">
                                <Link to={`/tours/${tourData.id}`}>
                                    <img 
                                        src={tourData.image} 
                                        alt={tourData.name}
                                        style={{ 
                                            height: "250px",
                                            objectFit: "cover",
                                            borderTopLeftRadius: '12px',
                                            borderBottomLeftRadius: '12px'
                                        }}
                                        onError={(e) => {
                                            e.target.src = fallbackImage;
                                        }}
                                    />
                                </Link>
                                
                                {/* Featured Badge */}
                                {tourData.isHighlighted && (
                                    <div className="position-absolute top-0 start-0 m-3">
                                        <span className="badge bg-warning text-dark">
                                            ⭐ Featured
                                        </span>
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* Tour Details */}
                        <div className="col-lg-8 col-md-7">
                            <div className="p-4 h-100 d-flex flex-column">
                                
                                {/* Header */}
                                <div className="mb-3">
                                    <div className="d-flex justify-content-between align-items-start mb-2">
                                        <h4 className="mb-0">
                                            <Link 
                                                to={`/tours/${tourData.id}`}
                                                className="text-primary text-decoration-none text-capitalize"
                                                style={{ 
                                                    fontWeight: '600',
                                                    fontSize: '20px',
                                                    lineHeight: '1.3'
                                                }}
                                            >
                                                {tourData.name.toLowerCase()}
                                            </Link>
                                        </h4>
                                    </div>
                                </div>

                                {/* Tour Info */}
                                <div className="mb-3 flex-grow-1">
                                    <div className="d-flex align-items-center gap-3 flex-wrap">

                                        {/* Location */}
                                        <div className="d-flex align-items-center text-muted">
                                            <FaMapMarkerAlt className="me-2" size={14} />
                                            <span className='text-capitalize'>{tourData.location.toLowerCase()}</span>
                                        </div>

                                        {/* Duration */}
                                        <div className="d-flex align-items-center">
                                            <span className="badge bg-light text-dark d-flex align-items-center gap-1">
                                                <FaClock size={12} />
                                                {tourData.duration}
                                            </span>
                                        </div>
                                       
                                    </div>
                                </div>

                                {/* description */}
                                <div className="mb-3">
                                    <div className="text-muted" dangerouslySetInnerHTML={{ __html: tourData.description.substring(0, 80) + '...' }} />
                                </div>

                                {/* Footer */}
                                <div className="d-flex justify-content-between align-items-center mt-auto pt-3" style={{ borderTop: '1px solid #e9ecef' }}>
                                    {/* Price */}
                                    <div className="price-info">
                                        <div className="d-flex align-items-baseline">
                                            <span className="h3 text-primary fw-bold mb-0">
                                                {tourData.currency}{tourData.price}
                                            </span>
                                            <small className="text-muted ms-2">per person</small>
                                        </div>
                                    </div>

                                    {/* Action Buttons */}
                                    <div className="action-buttons">
                                        <Link 
                                            to={`/tours/${tourData.id}`}
                                            className="btn btn-primary px-4 py-2"
                                            style={{
                                                borderRadius: '8px',
                                                fontWeight: '600'
                                            }}
                                        >
                                            View Details
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
} 